// pre check run profile
export const BufferTube = "BufferTube";
export const ProteinTube = "ProteinTube";

export const StartingVolume = "StartingVolume";
export const StartingConcentration = "StartingConcentration";
export const FinalVolume = "FinalVolume";
export const RequiresRefill = "RequiresRefill";
export const EstimatedFinalConcentration = "EstimatedFinalConcentration";

export const DiafiltrationMode = "DiafiltrationMode";
export const ExchangeStepSize = "ExchangeStepSize";
export const StepSizeVolume = "StepSizeVolume";
// parameters for discrete // parameters for continuous
export const VolumeToStartAt = "VolumeToStartAt";
export const BufferVolumeToUse = "BufferVolumeToUse";
export const TotalBufferVolumeToUse = "TotalBufferVolumeToUse";

export const MembraneCutOffSize = "MembraneCutOffSize";
export const ConicalVolume = "ConicalVolume";
export const Notes = "Notes";
export const Pressure = "Pressure";
export const MembraneType = "MembraneType";

export const ReturnValvePressure = "ReturnValvePressure";
export const VolumeChangeThreshold = "Threshold";

export const OperatingPressure = "OperatingPressure";
export const RecoveryOfLiquid = "RecoveryOfLiquid";
export const FlowRate = "FlowRate";
export const DiaphragmVacuumPressure = "DiaphragmVacuumPressure";
export const DiaphragmPressure = "DiaphragmPressure";
export const DiaphragmTiming = "DiaphragmTiming";
export const DiaphragmTimingOpen = "DiaphragmTimingOpen";
export const DiaphragmTimingClose = "DiaphragmTimingClose";
export const ValveTiming = "ValveTiming";
export const PrimeTiming = "PrimeTiming";
export const RecoveryTiming = "RecoverTiming";
export const PressureTimeLimit = "PressureTimeLimit";
export const CreatedAt = "CreatedAt";
export const ModifiedAt = "ModifiedAt";
export const ChipValve = "ChipValve";
export const MoreThan50ml = "MoreThan50ml";
export const SkipPriming = "SkipPriming";
export const AutoMixing = "AutoMixing";
export const StartingVolumeFor2ndTube = "StartingVolumeFor2ndTube";
export const PressureController = "PressureController";
export const MembraneFillingCycle = "MembraneFillingCycle";
export const ManualControlThreshold = "ManualControlThreshold";
export const Duration = "Duration";
export const IdAdvSetup = "IdAdvancedSetup";
export const AdvancedSetupName = "AdvancedSetupName";
export const PressureAdvSetup = "PressureAdvSetup";

export const CURRENT_VOLUME = "CurrentVolume";
export const DUMMY_VOLUME = "DummyVolume";
export const DUMMY_BUFFER = "DummyBuffer";

export const SourceOnThreshold = "SourceOnThreshold";
export const SourceOffThreshold = "SourceOffThreshold";
export const DrainOnThreshold = "DrainOnThreshold";
export const DrainOffThreshold = "DrainOffThreshold";
export const PressureSensorScale = "PressureSensorScale";
export const PressureSensorOffset = "PressureSensorOffset";
export const Id = "Id";
export const Name = "Name";
export const Config = "Config";
export const ConfigAdvSetup = "ConfigAdvSetup";
export const GeneralAdvSetup = "GeneralAdvSetup";
export const MainAdvSetup = "MainAdvSetup";
export const DiafiltrationAdvSetup = "DiafiltrationAdvSetup";
export const PrimeAdvSetup = "PrimeAdvSetup";
export const RecoveryAdvSetup = "RecoveryAdvSetup";
export const MixingAdvSetup = "MixingAdvSetup";
export const TubeMixingAdvSetup = "TubeMixingAdvSetup";
export const RecirculateAdvSetup = "RecirculateAdvSetup";
export const DefaultReturnValvePressure = "DefaultReturnValvePressure";
export const Default = "Default";
export const PreventLeaks = "PreventLeaks";
export const MixingSetup = "MixingSetup";
export const MixingCycle = "MixingCycle";
export const AutoMixingOn = "AutoMixingOn";
export const MixingMinutes = "MixingMinutes";
export const MPESReturnValvePressure = "MPESReturnValvePressure";
export const AutoRecoveryFlag = "AutoRecoveryFlag";
export const HighVolumeBufferFlag = "HighVolumeBufferFlag";

export const IsTotalBufferVolumeExpanded = "IsTotalBufferVolumeExpanded";

// Display Settings
export const FontSize = "FontSize";
// status key
export const CurrentPressure = "currentPressure";
export const PumpFlowRate = "pumpFlowRate";
export const ConcentrationFlowRate = "concentrationFlowRate";
export const CurrentVolume = "currentVolume";
export const EstimateConcentration = "estimateConcentration";
export const EstSecondRemaining = "estSecondsRemaining";
export const SecondElapsed = "secondsElapsed";
export const WarningMessage = "warningMessage";
export const CurrentBuffer = "currentBuffer";
export const FailureMessage = "failureMessage";
export const TransferVolume = "TransferVolume";
export const REQUIRE_REFILL = "requireRefill";

// TODO: fix typo
export const ProfileRunnig = "profileRunning";
export const PercentageComplate = "percentageComplete";
export const ManualControlStatus = "manualControlStatus";
export const ErrorParams = "errorParams";
export const Locked = "locked";
export const DeviceStatus = "status";
export const CurrentTiming = "currentTiming";
// recovery status
export const RecoveryOfLiquidStatus = "recoveryOfLiquidStatus";
export const RecoveryOfLiquidState = "RecoveryOfLiquidState";
export const CurrentRecoveryStatus = "CurrentRecoveryStatus";
export const CurrentRunTime = "CurrentRunTime";
export const TotalRunTime = "TotalRunTime";
export const CycleCount = "CycleCount";
export const IsComplete = "IsComplete";
export const NumberOfCycle = "NumberOfCycle";
export const CurrentPressureSensors = "currentPressureSensors";
export const CurrentVolumeChangesThreshold = "currentVolumeChangesThreshold";
export const ErrorVolumeChanges = "ErrorVolumeChanges";

// info page
export const FirmwareName = "FirmwareName";
export const FirmwareVersion = "FirmwareVersion";
export const SoftwareName = "SoftwareName";
export const SoftwareVersion = "SoftwareVersion";
export const HostName = "HostName";
export const IPAddress = "IpAddress";
export const MacAddress = "MacAddress";
export const BuildDate = "BuildDate";
export const DeviceSerialNo = "DeviceSerialNo";

export const LocalVersion = "LocalVersion";
export const LocalFile = "LocalFile";
export const RemoteVersion = "RemoteVersion";
export const IsUpdateAvailable = "IsUpdateAvailable";
export const Status = "Status";
export const DownloadProgress = "DownloadProgress";
export const BytesReceived = "BytesReceived";
export const TotalBytesReceived = "TotalByteReceived";
export const DownloadType = "DownloadType";
export const UpdateOperations = "UpdateOperations";
export const UpdateName = "UpdateName";

// Calibration
export const TubeScaleSensor = "TubeScaleSensor";
export const HeightSensor = "HeightSensor";
export const NormalizedSensor = "NormalizedSensor";
export const TubeScaleReference = "TubeScaleReference";
export const HeightReference = "HeightReference";
export const NormalizedReference = "NormalizedReference";
export const BufferSensor = "BufferSensor";
export const BufferReference = "BufferReference";
export const ProteinSensor = "ProteinSensor";
export const ProteinReference = "ProteinReference";
export const NormalizedBuffer = "NormalizedBuffer";
export const NormalizedProtein = "NormalizedProtein";

// volume sensor raw data
export const Protein0 = "sensor0";
export const Protein1 = "sensor1";
export const Buffer0 = "sensor2";
export const Buffer1 = "sensor3";
